import React, { Component, type ErrorInfo, type ReactNode } from 'react'

import styles from './styles.module.scss'

type MapBoundaryProps = {
  children: ReactNode
}

type MapBoundaryState = {
  hasError: boolean
}

class MapBoundary extends Component<MapBoundaryProps, MapBoundaryState> {
  state: MapBoundaryState = { hasError: false }

  static getDerivedStateFromError(): MapBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Homepage map failed to render', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <section className={styles.fallback} aria-live="polite">
          <div>
            <h2>Cross-border intelligence across Eurasia</h2>
            <p>The interactive map is temporarily unavailable.</p>
          </div>
        </section>
      )
    }

    return this.props.children
  }
}

export default MapBoundary
